document.addEventListener('DOMContentLoaded', () => {
    const boton = document.querySelector('.whatsapp-float');

    if (!boton) return;

    let ultimoScroll = window.scrollY;

    const ajustarPosicionPorCookies = () => {
        const banner = document.getElementById('cookie-banner');

        if (!banner) {
            document.documentElement.style.setProperty('--whatsapp-bottom', '2rem');
            return;
        }

        const estilos = window.getComputedStyle(banner);
        const bannerVisible = estilos.display !== 'none';

        if (!bannerVisible) {
            document.documentElement.style.setProperty('--whatsapp-bottom', '2rem');
            return;
        }

        const alturaBanner = banner.offsetHeight;
        const separacion = window.innerWidth < 768 ? 1.6 : 2.5;

        document.documentElement.style.setProperty(
            '--whatsapp-bottom',
            `calc(${alturaBanner}px + ${separacion}rem)`
        );
    };

    const controlarScroll = () => {
        const scrollActual = window.scrollY;

        if (scrollActual > ultimoScroll && scrollActual > 120) {
            boton.classList.add('whatsapp-float--minimized');
        } else {
            boton.classList.remove('whatsapp-float--minimized');
        }

        ultimoScroll = scrollActual;
    };

    ajustarPosicionPorCookies();
    controlarScroll();

    window.addEventListener('scroll', controlarScroll);
    window.addEventListener('resize', ajustarPosicionPorCookies);

    const observer = new MutationObserver(() => {
        ajustarPosicionPorCookies();
    });

    const banner = document.getElementById('cookie-banner');
    if (banner) {
        observer.observe(banner, {
            attributes: true,
            attributeFilter: ['style', 'class']
        });
    }
});